import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from "@angular/core";

@Component({
  selector: "app-accordion",
  templateUrl: "./accordion.component.html",
  styleUrls: ["./accordion.component.scss"],
})
export class AccordionComponent implements AfterViewInit {
  @Input() isCollapsed = false;
  @Input() title = "Panel header";
  @Input() description = "";

  @ViewChild("contentRef") contentRef!: ElementRef<HTMLDivElement>;

  ngAfterViewInit(): void {
    const el = this.contentRef.nativeElement;
    el.style.transition = "none";
    el.style.height = this.isCollapsed ? "0px" : "auto";
    el.style.overflow = this.isCollapsed ? "hidden" : "visible";
    el.style.opacity = this.isCollapsed ? "0" : "1";

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.style.transition = "height 0.3s ease, opacity 0.3s ease";
      });
    });
  }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
    this._animate();
  }

  private _animate(): void {
    if (!this.contentRef) return;
    const el = this.contentRef.nativeElement;

    if (!this.isCollapsed) {
      el.style.overflow = "hidden";
      el.style.height = "0px";
      void el.offsetHeight; // force reflow (required for Safari)
      el.style.height = el.scrollHeight + "px";
      el.style.opacity = "1";

      const onEnd = () => {
        el.style.height = "auto";
        el.style.overflow = "visible";
        el.removeEventListener("transitionend", onEnd);
      };
      el.addEventListener("transitionend", onEnd);
    } else {
      el.style.overflow = "hidden";
      el.style.height = el.scrollHeight + "px";
      void el.offsetHeight; // force reflow (required for Safari)
      el.style.height = "0px";
      el.style.opacity = "0";
    }
  }
}
